import { $stateParams } from '../../../../router';
import RegionService from '../RegionService';
import Pusher from 'pusher-js';

import {
	STREAM_CONNECTED_EVENT,
	STREAM_ACTIVE_EVENT,
	STREAM_DISCONNECTED_EVENT,
	STREAM_IDLE_EVENT
} from '../../constants';
import { Trigger } from '../_';

export const keys = {
	'eu'         : '5698f22f07752c2b2b5e',
	'us-e'       : '12765cb8133a2dfad431',
	'stage'      : 'e851137bf0fccca85d1d',
	'local'      : '9900b465851dead19df9'
};

export const clusters = {
	'eu'         : 'eu',
	'us-e'       : 'mt1',
	'stage'      : 'eu',
	'local'      : 'eu'
};

let pusher, channel;

export const SocketService = {

	channel: () => channel || null,

	init: () => {
		const region = RegionService.getRegion();
		pusher = new Pusher(keys[region], {
        	cluster: clusters[region],
        	authTransport: 'ajax'
        });
        channel = pusher.subscribe(`video-stream-${$stateParams.account_uuid}-${$stateParams.event_id}`);

        // Map pusher events to event service
        channel.bind('pusher:subscription_succeeded', () => {
        	channel.bind(STREAM_CONNECTED_EVENT, (data) => Trigger(STREAM_CONNECTED_EVENT, data));
        	channel.bind(STREAM_ACTIVE_EVENT, (data) => Trigger(STREAM_ACTIVE_EVENT, data));
        	channel.bind(STREAM_DISCONNECTED_EVENT, (data) => Trigger(STREAM_DISCONNECTED_EVENT, data));
        	channel.bind(STREAM_IDLE_EVENT, (data) => Trigger(STREAM_IDLE_EVENT, data));
        });
	},

	destroy: () => {
		channel.unbind();
		pusher.unsubscribe(`video-stream-${$stateParams.account_uuid}-${$stateParams.event_id}`);
	},

};

export default SocketService;